import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { toast } from 'react-hot-toast'

const GoogleCallback = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { login } = useAuthStore()

  useEffect(() => {
    const token = searchParams.get('token')
    
    if (token) {
      try {
        // Store the token
        login(token)
        toast.success('Google login successful!')
        navigate('/app/file-compare')
      } catch (error) {
        toast.error('Failed to process Google login')
        navigate('/login')
      }
    } else {
      toast.error('No token received from Google')
      navigate('/login')
    }
  }, [searchParams, login, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Processing Google login...</p>
      </div>
    </div>
  )
}

export default GoogleCallback 